<template>
  <div>
    <vs-card v-if="rowsTbl" class="mt-5">
      <div class="flex flex-col md:flex-row justify-between items-center mt-3 px-3">
        <div class="text-xl font-semibold">Contacts</div>
        <div class="mt-5 md:mt-0">
          <a-button type="danger" icon="delete" v-if="hasLenSelectedRow" @click="OpenModalMultiple" style="border-radius: 3px !important;">Delete</a-button>
          <a-button v-if="hasPermission('contact.create')" type="primary" @click="addContact" style="margin-left: 8px;border-radius: 3px !important;"><a-icon type="plus" /> New Contact </a-button>
        </div>
      </div>
      <a-divider />
      <a-tabs v-model="tabType" :default-active-key="1" @change="handleTabChangeFilter">
        <template #tabBarExtraContent>
          <div class="flex items-center gap-2">
            <ChipCustomizeCloseClearChipIcon v-if="$refs.contact" :items="$refs.contact.query.query" @deleteFilter="deleteFilter"/>
            <a-button type="primary" ghost @click="modalExportTbl" icon="filter" style="border-radius: 3px !important;">Filter And Export</a-button>
          </div>
        </template>
        <a-tab-pane :key="1" tab="All" force-render>
          <XTable
            :model="model"
            ref="contact"
            @rows="rowsTbl"
            @refresh="refresh"
            @selectedRows="selectedRows"
            @clickRow="(record)=>clickRow(`/contacts/edit/${record.id}`,'contact.get')"
            :options="{placeholder:'Search contacts', noContent: 'No contacts', is_row_selection: true, is_load_req: true,}"
          >
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item v-if="hasPermission('contact.get')" key="1" @click="toContactEdit(text.record.id)"><feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                  <a-menu-item v-if="hasPermission('contact.delete')" key="2" @click="removeItem(text.record.id)"> <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                  <a-menu-item v-if="hasPermission('contact.Note')" key="3" @click="addNoteItem(text.record.id)"><feather-icon icon="Edit3Icon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Add Note</a-menu-item>
                </a-menu>
                <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /></a-button>
              </a-dropdown>
            </span>
            <span slot="expandedRowRender" slot-scope="text,record">
              <a-descriptions bordered layout="vertical" :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }">
                <a-descriptions-item label="Emails">
                  <div v-for="item in text.text.emails">
                    <a-badge color="#3A3DBE" v-if="item.email_address" :text="item.email_address" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Websites">
                  <div v-for="item in text.text.websites">
                    <a-badge color="#3A3DBE" v-if="item.website_address" :text="item.website_address" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Phones">
                  <div v-for="item in text.text.phones">
                    <a-badge color="#3A3DBE" v-if="item.phone_number" :text="item.phone_number" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Addresses" :span="2">
                  <div v-for="(item,ind) in text.text.addresses">
                    <small class="font-bold" v-if="item.city">city:</small> {{ item.city }}
                    <br>
                    <small class="font-bold" v-if="item.post_code">postCode:</small> {{ item.post_code }}
                    <br>
                    <small class="font-bold" v-if="item.state">state:</small> {{ item.state }}
                    <br>
                    <small class="font-bold" v-if="item.street">street:</small> {{ item.street }}
                    <a-divider v-if="ind != text.text.addresses.length - 1"/>
                  </div>

                </a-descriptions-item>
              </a-descriptions>
          </span>
            <span slot="profile" slot-scope="text,record">
              <a-avatar v-if="text.record.avatar_url" :src="text.record.avatar_url" />
              <a-avatar v-else style="background:  #3A3DBE">
                {{ text.record.person ? text.record.person.first_name[0] + text.record.person.last_name[0] : text.record.company.name[0] }}
              </a-avatar>
            </span>
            <span slot="fullname" slot-scope="text,record">
              <a-button type="link" class="p-0" @click="redirectDashboard(text.record)">
                <template v-if="text.record.person">
                  {{ text.record.person.first_name + ' ' + text.record.person.last_name }}
                </template>
                <template v-else>
                  <div class="flex space-x-2">
                      <feather-icon icon="BriefcaseIcon" svg-classes="w-4 h-4 text-primary"></feather-icon>
                     <div>{{ text.record.company.name }}</div>
                  </div>
                </template>
              </a-button>
            </span>
            <span slot="company" slot-scope="text,record" v-if="text.record.company">
                {{ text.record.company.name  }}
            </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="Person" force-render>
          <XTable
            :model="model"
            ref="contactPerson"
            @rows="rowsTbl"
            @refresh="refresh"
            @selectedRows="selectedRows"
            @clickRow="(record)=>clickRow(`/contacts/edit/${record.id}`,'contact.get')"
            :options="options"
          >
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                  <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="hasPermission('contact.get')" key="1" @click="toContactEdit(text.record.id)"><feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                      <a-menu-item v-if="hasPermission('contact.delete')" key="2" @click="removeItem(text.record.id)"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                      <a-menu-item v-if="hasPermission('contact.Note')" key="3" @click="addNoteItem(text.record.id)"><feather-icon icon="Edit3Icon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Add Note</a-menu-item>
                    </a-menu>
                    <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /></a-button>
                </a-dropdown>
            </span>
            <span slot="expandedRowRender" slot-scope="text,record">
              <a-descriptions bordered layout="vertical" :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }">
                <a-descriptions-item label="Emails">
                  <div v-for="item in text.text.emails">
                    <a-badge color="#3A3DBE" v-if="item.email_address" :text="item.email_address" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Websites">
                  <div v-for="item in text.text.websites">
                    <a-badge color="#3A3DBE" v-if="item.website_address" :text="item.website_address" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Phones">
                  <div v-for="item in text.text.phones">
                    <a-badge color="#3A3DBE" v-if="item.phone_number" :text="item.phone_number" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Addresses" :span="2">
                  <div v-for="(item,ind) in text.text.addresses">
                    <small class="font-bold" v-if="item.city">city:</small> {{ item.city }}
                    <br>
                    <small class="font-bold" v-if="item.post_code">postCode:</small> {{ item.post_code }}
                    <br>
                    <small class="font-bold" v-if="item.state">state:</small> {{ item.state }}
                    <br>
                    <small class="font-bold" v-if="item.street">street:</small> {{ item.street }}
                    <a-divider v-if="ind != text.text.addresses.length - 1"/>
                  </div>

                </a-descriptions-item>
              </a-descriptions>
          </span>
            <span slot="profile" slot-scope="text,record">
              <a-avatar v-if="text.record.avatar_url" :src="text.record.avatar_url" />
              <a-avatar v-else style="background:  #3A3DBE">
                {{ text.record.person ? text.record.person.first_name[0] + text.record.person.last_name[0] : text.record.company.name[0] }}
              </a-avatar>
            </span>
            <span slot="fullname" slot-scope="text,record">
              <a-button type="link" class="p-0" @click="redirectDashboard(text.record)">
                <template v-if="text.record.person">
                  {{ text.record.person.first_name + ' ' + text.record.person.last_name }}
                </template>
                <template v-else>
                  <div class="flex space-x-2">
                      <feather-icon icon="BriefcaseIcon" svg-classes="w-4 h-4 text-primary"></feather-icon>
                     <div>{{ text.record.company.name }}</div>
                  </div>
                </template>
              </a-button>
            </span>
            <span slot="company" slot-scope="text,record" v-if="text.record.company">
                {{ text.record.company.name  }}
            </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane :key="3" tab="Company" force-render>
          <XTable
            :model="model"
            ref="contactCompany"
            @rows="rowsTbl"
            @refresh="refresh"
            @selectedRows="selectedRows"
            @clickRow="(record)=>clickRow(`/contacts/edit/${record.id}`,'contact.get')"
            :options="options"
          >
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                  <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="hasPermission('contact.get')" key="1" @click="toContactEdit(text.record.id)"><feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                      <a-menu-item v-if="hasPermission('contact.delete')" key="2" @click="removeItem(text.record.id)"> <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                      <a-menu-item v-if="hasPermission('contact.Note')" key="3" @click="addNoteItem(text.record.id)"><feather-icon icon="Edit3Icon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Add Note</a-menu-item>
                    </a-menu>
                    <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /></a-button>
                </a-dropdown>
            </span>
            <span slot="expandedRowRender" slot-scope="text,record">
              <a-descriptions bordered layout="vertical" :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }">
                <a-descriptions-item label="Emails">
                  <div v-for="item in text.text.emails">
                    <a-badge color="#3A3DBE" v-if="item.email_address" :text="item.email_address" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Websites">
                  <div v-for="item in text.text.websites">
                    <a-badge color="#3A3DBE" v-if="item.website_address" :text="item.website_address" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Phones">
                  <div v-for="item in text.text.phones">
                    <a-badge color="#3A3DBE" v-if="item.phone_number" :text="item.phone_number" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Addresses" :span="2">
                  <div v-for="(item,ind) in text.text.addresses">
                    <small class="font-bold" v-if="item.city">city:</small> {{ item.city }}
                    <br>
                    <small class="font-bold" v-if="item.post_code">postCode:</small> {{ item.post_code }}
                    <br>
                    <small class="font-bold" v-if="item.state">state:</small> {{ item.state }}
                    <br>
                    <small class="font-bold" v-if="item.street">street:</small> {{ item.street }}
                    <a-divider v-if="ind != text.text.addresses.length - 1"/>
                  </div>

                </a-descriptions-item>
              </a-descriptions>
          </span>
            <span slot="profile" slot-scope="text,record">
              <a-avatar v-if="text.record.avatar_url" :src="text.record.avatar_url" />
              <a-avatar v-else style="background:  #3A3DBE">
                {{ text.record.person ? text.record.person.first_name[0] + text.record.person.last_name[0] : text.record.company.name[0] }}
              </a-avatar>
            </span>
            <span slot="fullname" slot-scope="text,record">
              <a-button type="link" class="p-0" @click="redirectDashboard(text.record)">
                <template v-if="text.record.person">
                  {{ text.record.person.first_name + ' ' + text.record.person.last_name }}
                </template>
                <template v-else>
                  <div class="flex space-x-2">
                      <feather-icon icon="BriefcaseIcon" svg-classes="w-4 h-4 text-primary"></feather-icon>
                     <div>{{ text.record.company.name }}</div>
                  </div>
                </template>
              </a-button>
            </span>
            <span slot="company" slot-scope="text,record" v-if="text.record.company">
                {{ text.record.company.name  }}
            </span>
          </XTable>
        </a-tab-pane>
      </a-tabs>
    </vs-card>
    <vs-card class="py-5" v-else>
      <div class="container mx-auto text-center">
        <img src="../../../public/contact.svg" alt="">
        <h2>Manage contacts details</h2>
        <p class="text-base font-medium">
          This is where you can manage your contant information and <br/>
          view their purchase history
        </p>
        <div class="space-x-4">
          <vs-button color="primary" type="filled" class="font-bold" @click="addContact">Add Contact</vs-button>
          <vs-button color="primary" type="border" class="font-bold" @click="addContact()">Import contacts</vs-button>
        </div>
      </div>
    </vs-card>
    <a-modal centered :visible="open_add_note" title="Add Note" :width="700" @cancel="open_add_note = false">
      <a-form :form="form" @submit.prevent="handleNote">
        <div class="flex flex-col md:flex-row">
          <div class="w-full">
            <div class="grid grid-cols-1">
                <a-form-item label="Subject" has-feedback>
                  <a-input
                    v-decorator="['title',{ rules: [{ required: true, message: 'Please Enter Title Field.' }] }]"
                    autocomplete="none"
                  />
                </a-form-item>
                <a-form-item label="Note" has-feedback>
                  <a-textarea
                    v-decorator="['description',{ rules: [{ required: true, message: 'Please Enter description Field.' }] }]"
                    autocomplete="none"
                  />
                </a-form-item>

                <selectSearch
                      :required="true"
                      :options="optionSearchContact"
                      field="contact"
                      label="Contacts"
                      class="self-center flex-grow mt-8 md:mt-0 w-full md:w-2/3"/>

                <a-form-item label="Date" has-feedback>
                  <a-date-picker
                    v-decorator="['date',{ initialValue: current_date,rules: [{ required: true, message: 'Please Enter Date Field.' }] }]"
                    :format="dateFormat"
                    class="w-full md:w-1/3"
                  />
                </a-form-item>

                <a-divider/>
                <h4>Recorded time</h4>
                <p>Add a time entry to this note</p>
                <div class="flex flex-col md:flex-row space-x-0 md:space-x-4">
                  <a-form-item label="Time" has-feedback>
                    <a-input
                      v-decorator="['recorded_time',{ rules: [{ required: false, message: 'Please Enter Time field.' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'', required: false }] }]"
                      placeholder="recorded Time"
                      autocomplete="none"
                      :disabled="!stop_time"
                      addon-after="hour"
                      class="recorded_time"
                    />
                  </a-form-item>
                  <Timer @Timer="(timing)=>timer(timing,form,'recorded_time')" @startTime="startTime" :time="time" ref="timer" class="timer md:mt-5 md:mt-10"/>
                </div>
                <a-divider/>
                <h4>Notifications</h4>
                <p>Select firm users to receive notifications about this note.</p>
                <SelectOption
                  url="/account/list/"
                  label="Notification"
                  placeholder="notification"
                  field="notifications"
                  method="get"
                  mode="multiple"/>
              </div>
          </div>
        </div>
        <a-divider/>
        <div class="flex space-x-2">
          <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
          <a-button type="primary" ghost @click="open_add_note = false" style="border-radius: 3px !important;">Cancel</a-button>
        </div>
      </a-form>
    </a-modal>
    <a-modal  centered :visible="visible_export" title="Export" :footer="null" @cancel="visible_export = false">
      <a-radio-group v-model:value="radio_export">
        <a-radio :value="1">Select All Columns</a-radio>
        <a-radio :value="2">Select Custom Columns</a-radio>
      </a-radio-group>
      <a-divider/>
      <div class="flex space-x-2">
        <a-button type="primary" @click="exportTbl" :loading="loading" style="border-radius: 3px !important;">Export</a-button>
        <a-button type="primary" ghost @click="visible_export = false" style="border-radius: 3px !important;">Cancel</a-button>
      </div>
    </a-modal>
    <Drawer
      ref="drawer"
      :form="form"
      :ele="$refs[whichTabFilter]"
      :query="[
           { field : 'person__first_name', value: form.getFieldValue('first_name') , condition:'='},
           { field : 'person__last_name', value: form.getFieldValue('last_name') , condition: '=' },
           { field : 'person__birth_day', value: form.getFieldValue('birth_day') , condition: '=' },
           { field : 'company__name', value: form.getFieldValue('name') , condition: '=' },
           { field : 'email__email_address', value: form.getFieldValue('email_address') , condition: 'like' },
           { field : 'origination', value: form.getFieldValue('origination') , condition: '=' },
           { field : 'group', value: form.getFieldValue('group') , condition: '=' },
      ]"
    >
      <a-form-item label="FirstName" has-feedback>
        <a-input
          v-decorator="['first_name',{ rules: [{ required: false }] }]"
          autocomplete="none"
          class="ant-input"
        />
      </a-form-item>
      <a-form-item label="LastName" has-feedback>
        <a-input
          v-decorator="['last_name',{ rules: [{ required: false }] }]"
          autocomplete="none"
          class="ant-input"
        />
      </a-form-item>
      <a-form-item label="Company" has-feedback>
        <a-input
          v-decorator="['name',{ rules: [{ required: false }] }]"
          autocomplete="none"
          class="ant-input"
        />
      </a-form-item>
      <a-form-item label="Email" has-feedback>
        <a-input
          v-decorator="['email_address',{ rules: [{ required: false }] }]"
          autocomplete="none"
          class="ant-input"
        />
      </a-form-item>
      <a-form-item label="Birth day" has-feedback>
        <a-date-picker
          v-decorator="['birth_day',{ rules: [{ required: false }] }]"
          valueFormat="YYYY-MM-DD"
          :format="dateFormat"
          autocomplete="none"
        />
      </a-form-item>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'left',
          zIndex: 1,
        }"
      >
       <div class="flex gap-2">
         <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
           Save filter
         </a-button>
         <a-button type="primary" ghost @click="exportTbl" :loading="loadingExport" style="border-radius: 3px !important;">
           Export
         </a-button>
       </div>
      </div>
    </Drawer>
    <vs-prompt
      color="danger"
      title="Delete Contact"
      @cancel="delete_contact_multi = false"
      @close="delete_contact_multi = false"
      :active.sync="delete_contact_multi"
      buttons-hidden
    >
      <div class="text-left">
        <div class="font-medium">Are you sure you want to these contacts?</div>
      </div>
      <div class="flex justify-center space-x-3 mt-5">
        <vs-button color="danger" type="border" @click="delete_contact_multi = false">Cancel</vs-button>
        <vs-button color="danger" @click="deleteIteMultiple">Delete</vs-button>
      </div>
    </vs-prompt>
    <deleteItem
      :url="`/contact/${currentRow}/delete/`"
      subject="Delete Contact"
      :ele="$refs.contact"
      ref="contactItem"
    />
  </div>
</template>

<script>
    import * as TableCol from "./contactTbl";
    import XTable from "../../components/x-table/XTable";
    import axios from '@/axios'
    import Mixin from '../mixin/mixin'
    import selectSearch from '../forms/selectSearch'
    import SelectOption from '../forms/SelectOptionSingle'
    import Timer from "@/layouts/components/timer/Timer";
    import Drawer from '../drawer/Drawer'
    import Template from "@/views/template/Template";
    import ChipCustomizeCloseClearChipIcon from "@/views/components/vuesax/chip/ChipCustomizeCloseClearChipIcon";
    import deleteItem from "@/views/communications/deleteItem";

    const innerColumns = [
      { title: 'Emails', key: 'Emails', scopedSlots: { customRender: 'emails' }},
      { title: 'Websites', key: 'Websites', scopedSlots: { customRender: 'websites' }},
      { title: 'Phones', key: 'Phones', scopedSlots: { customRender: 'phones' }}
    ];

    export default {
        name: "Contact",
        mixins:[Mixin],
        components:{
          deleteItem,
          Template,
          XTable,
          selectSearch,
          SelectOption,
          Timer,
          Drawer,
          ChipCustomizeCloseClearChipIcon,
        },
        data(){
          return{
            model                : null,
            delete_contact       : false,
            open_add_note        : false,
            delete_contact_multi : false,
            currentRow           : null,
            innerColumns,
            innerDate            : [],
            selectedRow          : [],
            selectedKeys         : [],
            type_contact         :'All',
            visible_export       : false,
            radio_export         : 1,
            loading              : false,
            tabType              : 1,
            options              : {placeholder:'Search contacts', noContent: 'No contacts', is_row_selection: true, is_load_req: false,}
          }
        },

        methods:{

          modalExportTbl(){
            //this.visible_export = true
            this.$refs.drawer.visible_drawer = true
          },

          async deleteFilter(item){
            try {
              await this.$refs.contact.fetch()
              this.form.resetFields(item.field.includes('__') ? item.field.split('__')[1] : item.field )
            }catch (e) {
              throw new Error(e)
            }
          },

          async exportTbl() {
            try{
              this.loadingExport = true
              const columns = this.$refs.contact.cols
              const columns_filtered = columns.filter((item)=> item.key !=="person.first_name" && item.key!=="person.last_name" && item.key !=="person.middle_name" && item.key!=="profile" && item.key !== "action" && item.key !=="company" && item.show).map(item => ({[item.title]: this.hasDotValue(item.dataIndex) }))
              const result = columns_filtered.reduce(function(result, item) {
                let key = Object.keys(item)[0];
                result[key] = item[key];
                return result;
              }, {});
              const {data} = await axios.post('contact/query/',{ export: true, columns: result,query:this.$refs.drawer.query.filter((item)=>item.value), limit: 1000 })
              window.open(data.url,'_self')
            }catch (e) {
              this.$message.error('Error in export')
              throw new Error(e)
            }finally {
              this.loadingExport = false
            }
          },

          hasDotValue(value){
            if (value.includes('.')) {
              const arr = value.split('.')
              return arr[arr.length - 1]
            }
            return value
          },

          addNoteItem(id){
            this.open_add_note = true
            this.$nextTick(()=>this.form.setFieldsValue({ contact: id }))
          },

          startTime(){
            this.stop_time = false
            // if(this.form.getFieldValue('recorded_time'))
            //   this.$refs.timer.formattedElapsedTime = this.form.getFieldValue('recorded_time') * 3600
          },

          redirectDashboard(record){
            this.is_click_add_time = false
            this.$router.push(`/contacts/dashboard/${record.id}`)
            this.$store.commit('DASHBOARD_ID',record.id)
          },

          refresh(){
            this.type_contact = 'All'
          },

          selectedRows(records,keys){
            this.selectedRow = records.map(item=>item.id)
            this.selectedKeys = keys
          },

          addContact(){
            this.$router.push('/contacts/add')
          },

          removeItem(id){
            this.currentRow = id
            this.$refs.contactItem.open = true
          },

          OpenModalMultiple(){
            this.delete_contact_multi = true
          },

          async deleteIteMultiple(){
            try{
              this.$refs.contact.loading = true
              await axios.post('/contact/delete/multiple/',{contacts:this.selectedRow})
              await this.$refs.contact.fetch()
              this.delete_contact_multi = false
              this.$notification['success']({
                message: 'Success',
                description:'Your items successfully deleted!',
              });
              this.$refs.contact.selectedRowKeys = []
              this.selectedRow = []
            }catch (e){
              this.$ntSetError()
            }finally {
              this.$refs.contact.loading = false
            }
          },

          toContactEdit(id){
            this.$router.push(`/contacts/edit/${id}/`)
          },

          rowsTbl(rows){
            if(rows.length > 0){
              return true
            }
            return false
          },

          async handleTabChangeFilter(key){
            this.tabType = key
            const ref_value = key === 2 ? { ref: this.$refs.contactPerson , value : 1 } : { ref: this.$refs.contactCompany , value : 2 }
            ref_value.ref.data = []
            this.checkPagenation(ref_value.ref)
            ref_value.ref.query.query = [{ field:'contact_type',condition: '=',value: ref_value.value }]
            await ref_value.ref.fetch()
          },

        },

        computed:{
            hasLenSelectedRow() {
              return this.selectedRow.length > 0
            },
            whichTabFilter() {
              const tab = this.tabType
              if (tab === 1) return 'contact'
              if (tab === 2) return 'contactPerson'
              if (tab === 3) return 'contactCompany'
            }
        },

        mounted() {
          this.is_click_add_time = true

          if (this.$route.params.query) {
            this.$refs.contact.onSearch(this.$route.params.query)
          }
        },

        created() {
          this.model = TableCol.default
        }
    }
</script>
<style>
  .ant-btn-link,.text-indigo-600{
    color: #3A3DBE
  }
  .ant-table table {
    width: 100%;
    border-collapse: collapse !important;
    border-spacing: 0;
  }
  .content-area__heading h2{
    font-size: 16px !important;
  }
  .ant-table-row{
    cursor: pointer;
  }
  [dir=ltr] .ant-radio-button-wrapper:first-child{
    border-radius: 3px 0 0px 3px;
  }
  [dir=ltr] .ant-radio-button-wrapper:last-child{
    border-radius: 0 3px 3px 0;
  }
</style>
